import React, { useEffect, useState } from 'react'
import BasicView from '../../../../components_v1/Structure/Layouts/BasicView'
import GeneralInfo from '../views/GeneralInfo'
import StepperContainer from '../views/StepperContainer/StepperContainer'
import { contentData } from './content'
import { Grid } from '@material-ui/core'
import { nodata } from '../../../../texts/esp/general'
import { request_download_document, request_process } from '../requests'
import { isValidDocument, onGetErrorMessage } from '../../../../shared/utility'
import LoadingContainer from '../../../../components_v1/Structure/Layouts/LoadingContainer'

const StampingView = props => {

    const { match, history, language } = props

    const content = contentData[language]
    const processID = parseInt(match.params.id)

    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(null)
    const [error, setError] = useState(null)

    const [process, setProcess] = useState({})
    const [files, setFiles] = useState(null)

    useEffect(() => {
        const initModule = async () => {
            try {
                setLoading(true)
                const url = `proc_${content.url}`
                const _process = await request_process(processID, url, `?step_id=1`)
                setProcess(_process)
                
                let _files = []
                
                content.sections.general_info.fiscal.files.map(file => {
                    let _file = { ...file }
                    _file.status = isValidDocument(_process[file.key])
                    _files.push(_file)
                })

                setFiles(_files)

            } catch (error) {
                console.log(error)
                setError(onGetErrorMessage(error))
            }
            setLoading(false)
        }
        initModule()
    }, [])

    const onDownloadDocument = async (data) => {
        try {
            let _data = { params: { path: data.path } }
            await request_download_document(null, process[data.tableID], '', data.url, _data, true)
        } catch (error) {
            console.log(error)
            setError(onGetErrorMessage(error))
        }
    }
    return (
        <LoadingContainer loading={loading} success={success} error={error} onCloseSuccess={() => setSuccess(false)} onCloseError={() => setError(false)}>
            <BasicView title={process.fixed_name ? process.fixed_name : ''} setReturn>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <GeneralInfo
                            process={process}
                            files={files}
                            url={`proc_${content.url}`}
                            content={content.sections.general_info}
                            nodata={nodata}
                            onDownloadDocument={onDownloadDocument}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <StepperContainer
                            id={processID}
                            fixedID={content.fixed_id}
                            url={content.url}
                            language={language}
                            content={content.sections.stepper_container}
                            steps={content.monthly_steps}
                            paths={content.paths}
                        />
                    </Grid>
                </Grid>
            </BasicView>
        </LoadingContainer>
    )
}

export default StampingView